var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApexCharts',{attrs:{"type":"donut","options":_vm.options,"series":_vm.series,"height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }